import { Dexie, type EntityTable } from "dexie";
import { FragmentsMap } from "../views/playback/components/useLoadFragments";

export interface FragmentMapsDbEntry {
    id: string; // Primary key
    inner: FragmentsMap;
}

export const FragmentMapsDB = new Dexie("FragmentMapsDatabase") as Dexie & {
    fragmentMaps: EntityTable<FragmentMapsDbEntry, "id">;
};
FragmentMapsDB.version(1).stores({
    fragmentMaps: "++id, inner",
});
